import { combineReducers } from '@reduxjs/toolkit';

import { areasOfFocusReducer } from './ducks/areasOfFocus';
import { contentsReducer } from './ducks/contents';
import { errorReducer } from './ducks/error';
import { flashMessagesReducer } from './ducks/flashMessages';
import { gMapsErrorReducer } from './ducks/gMapsError';
import { gradSchoolsReducer } from './ducks/gradSchools';
import { internshipFunctionsReducer } from './ducks/internshipFunctions';
import { invitesReducer } from './ducks/invites';
import { invoicesReducer } from './ducks/invoices';
import { jobFunctionsReducer } from './ducks/jobFunctions';
import { layoutReducer } from './ducks/layout';
import { mainSearchReducer } from './ducks/mainSearch';
import { modalReducer } from './ducks/modal';
import { orgDashboardReducer } from './ducks/orgDashboard';
import { paymentMethodsReducer } from './ducks/paymentMethods';
import { postSearchReducer } from './ducks/postSearch';
import { searchRadiusReducer } from './ducks/searchRadius';
import { subscribedSubsitesReducer } from './ducks/subscribedSubsites';
import { userEnvironmentReducer } from './ducks/userEnvironment';
import { userLocationReducer } from './ducks/userLocation';
import { userNotificationsReducer } from './ducks/userNotifications';
import { volopFunctionsReducer } from './ducks/volopFunctions';
import { listingsReducer } from './slices/listingsSlice';
import { orgsReducer } from './slices/orgsSlice';

const reducers = {
  error: errorReducer,
  gMapsError: gMapsErrorReducer,
  userEnvironment: userEnvironmentReducer,
  userNotifications: userNotificationsReducer,
  userLocation: userLocationReducer,
  paymentMethods: paymentMethodsReducer,
  invites: invitesReducer,
  areasOfFocus: areasOfFocusReducer,
  jobFunctions: jobFunctionsReducer,
  internshipFunctions: internshipFunctionsReducer,
  volopFunctions: volopFunctionsReducer,
  orgs: orgsReducer,
  listings: listingsReducer,
  mainSearch: mainSearchReducer,
  modal: modalReducer,
  layout: layoutReducer,
  searchRadius: searchRadiusReducer,
  flashMessages: flashMessagesReducer,
  orgDashboard: orgDashboardReducer,
  invoices: invoicesReducer,
  contents: contentsReducer,
  postSearch: postSearchReducer,
  gradSchools: gradSchoolsReducer,
  subscribedSubsites: subscribedSubsitesReducer,
};

export const mainRootReducer = combineReducers(reducers);
